import type { ProspectPainTypeValue, ProspectSignalStatus } from '@crm/shared';
import api from './api';

export interface ProspectSignal {
  id: number;
  sourceUrl: string;
  communityName: string | null;
  authorHandle: string;
  language: string;
  painType: string;
  authorLevel: string;
  intensity: number;
  score: number;
  evidenceQuote: string;
  reasoning: string;
  classifiedAt: string;
  dismissedAt: string | null;
  promotedLeadId: number | null;
}

export interface ProspectSignalListParams {
  productId: number;
  minScore?: number | undefined;
  painType?: ProspectPainTypeValue | undefined;
  status?: ProspectSignalStatus | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface ProspectSignalListResponse {
  data: ProspectSignal[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export interface PromoteSignalBody {
  stageId: number;
  assignedUserId: number;
  name?: string;
}

/**
 * Monta os params omitindo o que está vazio. Axios serializaria `undefined`
 * fora da querystring, mas string vazia iria — e `painType=` toma 400 na
 * validação `isIn` da rota.
 */
function toParams(params: ProspectSignalListParams): Record<string, string | number> {
  const out: Record<string, string | number> = { productId: params.productId };
  if (params.minScore !== undefined) {
    out.minScore = params.minScore;
  }
  if (params.painType) {
    out.painType = params.painType;
  }
  if (params.status) {
    out.status = params.status;
  }
  if (params.page !== undefined) {
    out.page = params.page;
  }
  if (params.limit !== undefined) {
    out.limit = params.limit;
  }
  return out;
}

export const prospectSignalsService = {
  list: (params: ProspectSignalListParams) =>
    api
      .get<ProspectSignalListResponse>('/prospect-signals', { params: toParams(params) })
      .then((r) => r.data),

  promote: (id: number, body: PromoteSignalBody) =>
    api.post(`/prospect-signals/${id}/promote`, body).then((r) => r.data),

  dismiss: (id: number) => api.post(`/prospect-signals/${id}/dismiss`).then((r) => r.data),
};
